import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit {

    constructor() {
        // console.log('Main layout constructor called');
    }
    public shouldShow = false;
    title = 'iam';

    animation = 'pulse';
    contentLoaded = false;
    intervalId;

    ngOnInit() {

        setTimeout(() => {
            this.contentLoaded = true;
        }, 2000);

        this.intervalId = setInterval(() => {
            this.animation = this.animation === 'pulse' ? 'progress-dark' : 'pulse';
        }, 5000);
    }

    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

}
